// extracted by mini-css-extract-plugin
export default {"attUploading":"attUploading-module--attUploading--if5-+","uploadingText":"attUploading-module--uploadingText--C10hd","cancelSend":"attUploading-module--cancelSend--uzgS4"};